<div id="top-banner-container" class="unselectable">
  <img id="top-banner" [src]="'assets/images/logos_top-menu.png'" alt="">
<!--  <div id="phaser-div"></div>-->
</div>
